import React from 'react';
import { useTranslation } from 'react-i18next';

import AccessScopeEditor from '../../../components/ui/AccessScopeEditor';

export default function GateGroupScopeTab({ groupId }) {
  const { t } = useTranslation();
  return (
    <AccessScopeEditor
      scopeUrl={`/v1/gate-groups/${groupId}/scope`}
      includeAllHint={t('gateGroup.scopeIncludeAllHint')}
    />
  );
}
